import React from "react";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import MainSearch from "components/Search/MainSearch.jsx";
import Parallax from "components/Parallax/Parallax.js";
import Button from "components/CustomButtons/Button.js";
import Meta from "components/Helmet/Meta.jsx";
import youtubeImg from "assets/img/youtube-logo.png";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import headersStyle from "assets/jss/trip-kit/views/sectionsSections/headersStyle.js";

//언어 셋팅
import { withTranslation } from "react-i18next";
import i18n from "config/lang/i18n.js";

const useStyles = makeStyles(headersStyle);

const MainTheme = (props) => {
    const classes = useStyles();
    const metaData = {
      title: i18n.t('mainTitle') + "|Korea Travel|tripCheckiner"
    }
    return (
      <Parallax image={require('assets/img/Gyeongbokgung.jpg')} filter="dark" small>
      <Meta data={metaData} />
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
            <h2 className={classes.title}>Checkin Your Korea</h2>
            <h4><span className={classes.subTitle}>{i18n.t('mainTheme')}</span></h4>
          </GridItem>
        </GridContainer>
        <MainSearch {...props} xs1={4} xs2={4}/>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
            <a href="https://www.youtube.com/@tripcheckiner"  target='_blank' rel='nofollow noopener noreferrer'>
            <Button color="github"  style={{textTransform:"none",padding:15,paddingTop:0,paddingBottom:0,borderRadius:"10px",marginLeft:10}}>
              <img style={{width:"70px",marginRight:"7px",verticalAlign:"bottom"}} src={youtubeImg} alt="Youtube" /><span style={{marginLeft:0}}>
                <h3 className={classes.title} style={{paddingTop:0 ,marginTop:10}}>Youtube</h3></span>
            </Button>
            </a>
          </GridItem>
        </GridContainer>
      </div>
    </Parallax>
    );
};

export default withTranslation()(MainTheme);
